import { connect } from 'react-redux';
import MenuCategorias from "../components/MenuCategorias";

const mapStateToProps = (state) => {
    return {        
        categorias: state.menuCategorias.categorias
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return { 
    }
}

const ConnectedMenuCategorias = connect(
    mapStateToProps,
    mapDispatchToProps
)(MenuCategorias)

export default ConnectedMenuCategorias;


// WEBPACK FOOTER //
// ./Portico/App/Screens/MenuCategorias/Components/MenuCategoriasContainer.jsx